import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

// Convention Python : lundi = 0 … dimanche = 6
const SETS = {
  week: { label: "Semaine", detail: "nuits du dimanche soir au jeudi soir", weekdays: [6, 0, 1, 2, 3] },
  weekend: { label: "Week-end", detail: "nuits du vendredi soir et du samedi soir", weekdays: [4, 5] },
};

const HORIZON_MONTHS = 24;

export default function QuickRates({ slug, onDone }) {
  const [prices, setPrices] = useState({ week: "", weekend: "" });
  const [busy, setBusy] = useState(null);

  const apply = async (key) => {
    const value = Number(prices[key]);
    if (!value || value <= 0) return toast.error("Indiquez un tarif par nuit");
    const today = new Date();
    const start = today.toISOString().slice(0, 10);
    const horizon = new Date(today.getFullYear(), today.getMonth() + HORIZON_MONTHS, today.getDate());
    setBusy(key);
    try {
      const { data } = await api.put("/admin/prices/range", {
        gite_slug: slug, start, end: horizon.toISOString().slice(0, 10),
        weekdays: SETS[key].weekdays, price: value, closed: false, reset: false,
      });
      toast.success(`${SETS[key].label} à ${value} € — ${data.updated} nuits à venir mises à jour`);
      setPrices({ ...prices, [key]: "" });
      onDone();
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    } finally { setBusy(null); }
  };

  return (
    <div className="mt-5 border border-brass/40 bg-panel p-5" data-testid="quick-rates">
      <h3 className="font-display text-xl text-bone">Tarifs de base à venir</h3>
      <p className="mt-1 text-xs text-muted-foreground">
        Applique le tarif à toutes les nuits concernées, d'aujourd'hui jusqu'à {HORIZON_MONTHS} mois.
        Les nuits déjà réservées gardent le prix payé par le voyageur ; vous pourrez toujours
        ajuster une période précise ensuite.
      </p>

      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        {Object.entries(SETS).map(([key, s]) => (
          <div key={key} className="border border-white/10 p-4">
            <p className="text-sm font-semibold text-bone">{s.label}</p>
            <p className="mt-0.5 text-[11px] text-muted-foreground">{s.detail}</p>
            <div className="mt-3 flex flex-wrap items-end gap-3">
              <label className="text-sm">
                <span className="mb-1.5 block text-xs text-bone">Prix par nuit (€)</span>
                <input type="number" min="0" step="1" className="field !py-2 w-32"
                  data-testid={`quick-${key}-price`} value={prices[key]} placeholder="ex : 165"
                  onChange={(e) => setPrices({ ...prices, [key]: e.target.value })} />
              </label>
              <button className="btn-primary !py-2.5" data-testid={`quick-${key}-apply`}
                disabled={busy === key || !prices[key]} onClick={() => apply(key)}>
                {busy === key ? "Application…" : "Appliquer"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
